import { Outlet } from 'react-router-dom'
import { GlobalNavigation } from './global-navigation'
import { useGlobalChatNotifications } from '@/lib/hooks/use-global-chat-notifications'
import { BugReportSection } from './BugReportSection'

export default function Layout() {
  // Subscribe to all conversations for global notifications
  useGlobalChatNotifications()

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      <GlobalNavigation />
      <div className="flex-1">
        <Outlet />
      </div>
      <BugReportSection />
    </div>
  )
}
